// React import
import { Container, Draggable } from '@edorivai/react-smooth-dnd';

// Generic imports
import _ from 'lodash';
import { arrayMoveImmutable } from 'array-move';

// Mui imports
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import DragHandleIcon from '@mui/icons-material/DragHandle';

function TitleableReorders(props) {
    const { modal, setModal, offers, setOffers, onChange } = props;

    const onDrop = ({ removedIndex, addedIndex }) => {
        setModal(modal => ({...modal, items: arrayMoveImmutable(modal.items, removedIndex, addedIndex)}));
    };

    function onOk() {
        if (setOffers) {
            const newOffers = _.cloneDeep(offers);
            _.set(newOffers, modal.path, modal.items);
            setOffers(newOffers);
        } else {
            onChange(modal.items);
        }
        setModal({ ...modal, open: false });
    }

    return (
        <Modal open={modal.open} onClose={() => setModal({ ...modal, open: false })} >
            <Card sx={{ ...MODAL_STYLE, width: '560px'}}>
                <CardContent>
                    <Typography gutterBottom variant='h5' component='div'>
                        {modal.title}
                    </Typography>
                    <List>
                        <Container dragHandleSelector='.drag-handle' lockAxis='y' onDrop={onDrop}>
                            {(modal.items || []).map(({ id, title }) => (
                                <Draggable key={id}>
                                    <ListItem>
                                        <ListItemText primary={title} />
                                        <ListItemSecondaryAction>
                                            <ListItemIcon className='drag-handle'>
                                                <DragHandleIcon />
                                            </ListItemIcon>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </Draggable>
                            ))}
                        </Container>
                    </List>
                </CardContent>
                <CardActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button size='small' color='secondary' onClick={() => { setModal({ ...modal, open: false }) }}>
                        Cancel
                    </Button>
                    <Button
                        size='small' 
                        color='primary' 
                        variant='contained' 
                        onClick={() => {
                            onOk()
                        }}
                    >
                        OK
                    </Button>
                </CardActions>
            </Card>
        </Modal>
    );
}

export default TitleableReorders;

const MODAL_STYLE = {
    position: 'absolute',
    top: '50px',
    left: 'calc(50% - 280px)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

